import polyline from '@mapbox/polyline';
import type { MapPosition } from '../types';

export const decodeEncodedRoute = (encodedRoute?: string): MapPosition[] => {
  if (!encodedRoute) {
    return [];
  }

  try {
    return polyline.decode(encodedRoute).reverse();
  } catch {
    return [];
  }
};
